import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./pages/context/AuthContext";
import { ThemeProvider } from "./pages/context/ThemeContext";
import PrivateRoute from "./pages/components/PrivateRoute";
import Login from "./pages/login";
import MenuLateral from "./pages/menu";
import Dashboard from "./pages/dashboard";
import Popup from "./pages/popUp";
import Rastreamento from "./pages/rastreamento";
import CriarRota from "./pages/newroute";
import ContractManagement from './pages/contractManagement';
import PreRomaneio from './pages/preRomaneio';
import SugestaoVeiculo from "./pages/vehicleSuggestion";
import Register from "./pages/register";
import VisualizarRotas from './pages/visualizar-rotas';

function App() {
  const [showPopup, setShowPopup] = useState(true); // Estado para controle do popup

  const closePopup = () => {
    setShowPopup(false); // Fecha o popup ao clicar em "Entendido"
  };

  // Add styles to prevent overscroll and set background
  React.useEffect(() => {
    // Prevent overscroll behavior
    document.body.style.overscrollBehavior = 'none';
    document.documentElement.style.overscrollBehavior = 'none';
    
    // Set body background to match theme
    document.body.style.backgroundColor = 'var(--bg-color, #f8f9fa)';
    document.documentElement.style.backgroundColor = 'var(--bg-color, #f8f9fa)';
    
    // Add CSS custom properties for theme colors
    const root = document.documentElement;
    const isDark = document.documentElement.classList.contains('dark');
    
    if (isDark) {
      root.style.setProperty('--bg-color', '#1a1a1a');
    } else {
      root.style.setProperty('--bg-color', '#f8f9fa');
    }

    // Cleanup function
    return () => {
      document.body.style.overscrollBehavior = '';
      document.documentElement.style.overscrollBehavior = '';
    };
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <div style={{ 
          minHeight: '100vh', 
          overscrollBehavior: 'none',
          backgroundColor: 'inherit'
        }}>
          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/registro" element={<Register />} />

              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <Dashboard />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/rastreio"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <Rastreamento />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/criar-rota"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <CriarRota />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/gestao-contratos"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <ContractManagement />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/pre-romaneio"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <PreRomaneio />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/sugestao-veiculo"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <SugestaoVeiculo />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="/visualizar-rotas"
                element={
                  <PrivateRoute>
                  <div className="flex bg-white-less dark:bg-dark-bg min-h-screen">
                    {showPopup && <Popup onClose={closePopup} />}
                    <MenuLateral />
                    <div className="flex-1">
                      <VisualizarRotas />
                    </div>
                  </div>
                  </PrivateRoute>
                }
              />

              <Route
                path="*"
                element={<h1 className="text-center text-red-500">404 - Página não encontrada</h1>}
              />
            </Routes>
          </Router>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
